import script from "./userAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./userAvatar.vue?vue&type=script&setup=true&lang=js"

import "./userAvatar.vue?vue&type=style&index=0&id=6579f42f&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6579f42f"]])

export default __exports__